import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import './SignIn.css';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const res = await fetch(`${BACKEND_URL}/api/auth/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email.trim().toLowerCase() }),
      });
      // Backend intentionally always 200s to prevent user enumeration;
      // treat any non-2xx as a real error (malformed email etc).
      if (!res.ok) {
        const body = await res.json().catch(() => ({}));
        const detail = Array.isArray(body?.detail)
          ? body.detail.map(d => d.msg || JSON.stringify(d)).join(' ')
          : (body?.detail || 'Could not send reset link. Please try again.');
        throw new Error(detail);
      }
      setSent(true);
    } catch (err) {
      setError(err.message || 'Could not send reset link. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth">
      <div className="auth-l">
        <div className="streak" style={{ top: '30%', right: '-20px', width: '240px' }}></div>
        <div className="streak" style={{ top: 'calc(30% + 12px)', right: '-20px', width: '160px', opacity: '0.5' }}></div>
        <div className="brandrow">
          <img className="mark" src="/logos/instacut-mark-28.svg" alt="" width="28" height="28" />
          Instacut
        </div>
        <h3>Forgot your<br />password?</h3>
        <p>No worries — happens to the best of us. Pop in the email address you use for Instacut and we&apos;ll send you a reset link.</p>
        <div className="quote">&ldquo;Links land in your inbox in about 30 seconds — check spam if it&apos;s taking longer.&rdquo;</div>
      </div>

      <div className="auth-r">
        <h4>Reset your password</h4>
        <div className="s">We&apos;ll email you a secure link to set a new one.</div>

        {sent ? (
          <div data-testid="forgot-sent">
            <div
              className="error-message"
              style={{
                background: 'var(--paper)',
                borderColor: 'var(--line)',
                color: 'var(--ink)',
              }}
            >
              <strong>Check your inbox.</strong>
              <div style={{ marginTop: 6, color: 'var(--mute)' }}>
                If an Instacut account exists for <b>{email}</b>, a password-reset link is on its way. The link expires in 1 hour.
              </div>
            </div>
            <Link
              to="/signin"
              className="btn"
              style={{ width: '100%', justifyContent: 'center', padding: '12px', textDecoration: 'none' }}
              data-testid="forgot-back-to-signin"
            >
              <ArrowLeft size={14} /> Back to sign in
            </Link>
          </div>
        ) : (
          <form onSubmit={submit}>
            {error && (
              <div className="error-message" data-testid="forgot-error">
                {error}
              </div>
            )}

            <div className="field">
              <label>Email</label>
              <input
                className="inp"
                type="email"
                autoFocus
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                disabled={loading}
                placeholder="you@example.com"
                data-testid="forgot-email"
              />
            </div>

            <button
              type="submit"
              className="btn p"
              disabled={loading || !email}
              style={{ width: '100%', justifyContent: 'center', padding: '12px' }}
              data-testid="forgot-submit"
            >
              {loading ? 'Sending…' : 'Send reset link'}
            </button>

            <div style={{ textAlign: 'center', fontSize: '12.5px', color: 'var(--mute)', marginTop: '18px' }}>
              Remembered it? <Link to="/signin" style={{ color: 'var(--acc)', fontWeight: 600, textDecoration: 'none' }} data-testid="forgot-signin-link">Sign in →</Link>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default ForgotPassword;
